export function hashString(str) {
    // Basic hash function to create a unique number from a string
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    return Math.abs(hash)
}

export function getColorForValue(value) {
    const colorMap = {}
    if (!colorMap[value]) {
        // Generate a color based on a hash of the value
        const hue = hashString(value) % 360
        const color = `hsl(${hue}, 70%, 50%)` // 70% saturation, 50% lightness for distinct colors

        colorMap[value] = color
    }
    return colorMap[value]
}
